import { Component, Vue } from 'vue-property-decorator'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { getMarketCooperationPrevLevel } from '@/api/common'
import { setMarketCooperationStatusById, getProjectAllGroupPriceListBySouCourseTypeId, getProjectAllListBySouCourseTypeId } from '@/api/market'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { souCoueTypeList } from '@/views/marketing/Cooperation-management/new-partner/data'
import { delNullProperty } from '@/utils/index'
import { Loading } from 'element-ui'
@Component({
    filters: {
        timeFilter: (val: string) => (formatDate('yyyy-MM-dd hh:mm', new Date(val))),
        projectType: (souCourseTypeIdList: number[]) => {
            let souCourseTypeName = ''
            souCoueTypeList.forEach((item) => {
                if (souCourseTypeIdList.includes(item.value)) {
                    const nameArr = souCourseTypeName.split('+')
                    // 判断当前生成的名字中有几个 +
                    if (nameArr.length === souCourseTypeIdList.length) {
                        souCourseTypeName += item.label
                    } else {
                        souCourseTypeName += item.label + '+'
                    }
                }
            })
            return souCourseTypeName
        }
    }
})
export default class SeePartner extends Vue {
    // data
    checkedLeval = false //同步下级
    partnerName = ''
    id = 0
    operationShow = false // 操作日志显示隐藏
    data: any = ''
    dissertation_list = []
    type = ''
    reviewStatus = '' // 审批流状态
    status = 1 // 审批通过或者驳回时需要用到的状态  1- 通过 2-驳回
    // 可编辑字段
    editFiles = {
        name: '',
        marketCooperationId: '',
        source: '',
        types: '',
        contact: '',
        contactInfo: '',
        invoiceType: '',
        invoiceTitle: '',
        invoiceCode: '',
        invoiceBank: '',
        invoiceAccount: '',
        invoiceAddress: '',
        invoicePhone: '',
    }
    editFileList = []
    editFileIsRequired = false // 可编辑字段是否必填
    cancleReview = false // 撤回审批弹窗
    reviewDialog = false // 审批弹窗
    opinion = '' // 审批意见
    marketCooperationPrevLevelList = []// 上级合作伙伴列表

    projectTypeDialogShow = false
    projectTypeDialogTitle = ''
    projectTypeTableData = []
    projectTypeTableData_ = []
    projectPriceDialogShow = false
    editProjectTypePriceDialogShow = false
    projectPricetableData = [] // 项目列表
    projectPricetableHeadData = [
        { label: '项目编号', prop: 'souCourseIndex' },
        { label: '项目名称', prop: 'souCourseName' },
        // { label: '双课题备注', prop: 'doubleSouCourseName' },
        { label: '开课时间', prop: 'date' },
        { label: '导师名字', prop: 'souTeacherName' },
        { label: '项目定价', prop: 'souCoursePrice' },
        { label: '结算价', prop: 'price' },
    ]
    projectPriceFilterObj = {
        souCourseName: '',
        schoolBeginAt: [],
        souTeacherName: '',
        souCoursePrice: '',
        page: 1,
        limit: 20,
    }
    total = 0
    souCourseTypeId = undefined
    disBtn=false
    marketLevelPage = 1
    marketLevelSize = 20
    // marketLevelTotal = 0
    cooperativePartnerName = ''
    marketLevelloading = false
    sourceNameId = null
    sourceName = ''
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回

    // created
    created() {
        const query = this.$route.query
        this.id = Number(query.id)
        this.type = this.$route.query.type as string    //1 查看
        this.reviewStatus = this.$route.query.status as string
        this.types = this.$route.query.types as string
        if((this.type == '1') && (this.reviewStatus != "0")){
            this.operationShow = true
        }
        this.getData()
    }

    // 获取详细信息
    async getData() {
        const data: any = await getMessageReviewById(this.id,this.types)
        this.data = data.result
        if(this.data.isAsync == '1'){ this.checkedLeval = true}
        if(this.data.isAsync == '0'){ this.checkedLeval = false}
        this.dissertation_list = this.data.marketCooperationProjectDissertationCommissionList
        this.dissertation_list.forEach(item => {
            if (item.commissionType == '') {
                return item.commissionType = '2'
            }
        })
        this.editFileList = this.data.editFileList || []
        // 可编辑字段对应
        this.editFileList.forEach(item => {
            if (item.cnFile === '关联上级') this.getMarketCooperationPrevLevel()
            item.file === 'name' && (this.editFiles.name = this.data.name)
            item.file === 'marketCooperationId' && (this.editFiles.marketCooperationId = this.data.marketCooperationId)
            item.file === 'source' && (this.editFiles.source = this.data.source)
            item.file === 'types' && (this.editFiles.types = this.data.types)
            item.file === 'contact' && (this.editFiles.contact = this.data.contact)
            item.file === 'contactInfo' && (this.editFiles.contactInfo = this.data.contactInfo)
            switch (item.file) {
                case 'invoiceType':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.types
                    break;
                case 'invoiceTitle':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.title
                    break;
                case 'invoiceCode':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.code
                    break;
                case 'invoiceBank':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.bank
                    break;
                case 'invoiceAccount':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.account
                    break;
                case 'invoiceAddress':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.address
                    break;
                case 'invoicePhone':
                    this.editFiles[item.file] = this.data.marketCooperationInvoice.phone
                    break;
                default:
                    break;
            }
        });
        if(this.editFileList && this.editFileList.length > 0) this.editFileIsRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.partnerName = this.data.name
        this.data.marketCooperationCommissionList.forEach(item => {
            item.souCourseTypeIdList && (item.souCourseTypeIdList = item.souCourseTypeIdList.map(id => Number(id)))
        })
        this.stepNode.isFirstNode = this.data.isFirstNode
        this.stepNode.isSyncEkuaibao = this.data.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.data.isSyncEqianbao
    }

    // 获取可关联上级的数据
    // async getMarketCooperationPrevLevel() {
    //     const data: any = await getMarketCooperationPrevLevel({ id: this.data.id })
    //     this.marketCooperationPrevLevelList = data.marketCooperation
    // }

    // 字段是否可编辑
    fileIsEdit(name: string): boolean {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.cnFile === name)
    }

    // 审批
    openReviewDialog(status: number) {
        this.status = status
        this.approvedVisible = true
    }

    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    // 审批通过确认
    async reviewDialogConfirm() {
        // 非空判断
        if (this.editFileIsRequired) {
            const bol = this.editFileList.every(item => {
                if (!this.editFiles[item.file]) this.$message.error(`${item.cnFile}不能为空`)
                return this.editFiles[item.file]
            })
            if (!bol) return
        }
        const param = {
            messageReviewId: this.id,
            status: this.status,
            opinion: this.opinion,
            form: {},
            nodeType: this.nodeType,
            // isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
        }

        this.editFileList.forEach(item => param.form[item.file] = this.editFiles[item.file])
        this.disBtn = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        await setMessageReviewUserByMessageReviewId(param)
        this.$message.success(`审批已${this.status === 1 ? '通过' : '驳回'}，页面即将关闭`)
        this.reviewDialog = false
        loading.close()
        setTimeout(() => {
            window.close()
        }, 1500)
    }
    // 通过
    async approvedConfirm() {
        // 非空判断
        if (this.editFileIsRequired) {
            const bol = this.editFileList.every(item => {
                if (!this.editFiles[item.file]) this.$message.error(`${item.cnFile}不能为空`)
                return this.editFiles[item.file]
            })
            if (!bol) return
        }
        const param = {
            messageReviewId: this.id,
            status: this.status,
            opinion: this.opinion,
            form: {},
            // nodeType: this.nodeType,
            isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
        }
        
        this.editFileList.forEach(item => param.form[item.file] = this.editFiles[item.file])
        this.disBtn = true
        const loading = Loading.service({
            text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
        })
        await setMessageReviewUserByMessageReviewId(param)
        this.$message.success(`审批已${this.status === 1 ? '通过' : '驳回'}，页面即将关闭`)
        this.reviewDialog = false
        loading.close()
        setTimeout(() => {
            window.close()
        }, 1500)
    }

    // 撤回审批
    async cancleReviewDialogConfirm() {
        await setMarketCooperationStatusById(this.data.id)
        this.$message.success('成功撤回审批，页面即将关闭')
        this.cancleReview = false
        setTimeout(() => {
            window.close()
        }, 1500)
    }

    async openProjectTypePriceDialog(souCourseTypeIdList: number[], item) {
        let projectAllGroupPriceList = item.projectAllGroupPriceList || []
        this.projectTypeDialogTitle = this.getMultipleSouCourseTypeName(souCourseTypeIdList)
        this.souCourseTypeId = souCourseTypeIdList
        if(projectAllGroupPriceList.length === 0) {
            const data = await getProjectAllGroupPriceListBySouCourseTypeId({ id: this.id + '', souCourseTypeIdList: souCourseTypeIdList  }) as unknown as { projectAllGroupPriceList: any[] }
            projectAllGroupPriceList = data.projectAllGroupPriceList
        }
        this.projectTypeTableData = projectAllGroupPriceList.filter(item => !item.isSetting)
        this.projectTypeTableData_ = projectAllGroupPriceList.filter(item => item.isSetting)
        this.projectTypeDialogShow = true
    }

    async editProjectTypePriceDialogShowChange(type: number) {
        if(type === 1) {
            this.getProjectAllListBySouCourseTypeId()
            this.projectTypeDialogShow = false
            this.projectPriceDialogShow = true
        }
        if(type === 2) {
            this.projectTypeDialogShow = true
            this.projectPriceDialogShow = false
        }
    }

    handleSizeChange(limit: number) {
        this.projectPriceFilterObj.limit = limit
        this.getProjectAllListBySouCourseTypeId()
    }

    handleCurrentChange(page) {
        this.projectPriceFilterObj.page = page
        this.getProjectAllListBySouCourseTypeId()
    }

    async getProjectAllListBySouCourseTypeId() {
        const obj = {}
        for(const key in this.projectPriceFilterObj) {
            obj[key] = this.projectPriceFilterObj[key]
        }
        if(this.projectPriceFilterObj.schoolBeginAt.length > 1 && Array.isArray(this.projectPriceFilterObj.schoolBeginAt)) {
            obj['schoolBeginAt'] = formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.projectPriceFilterObj.schoolBeginAt[1]))
        } else {
            obj['schoolBeginAt'] = ''
        }
        const { allNum, projectAllList } = await getProjectAllListBySouCourseTypeId(delNullProperty({
            ...obj,
            souCourseTypeIdList: this.souCourseTypeId,
            projectAllGroupPriceList: [...this.projectTypeTableData, ...this.projectTypeTableData_]
        })) as unknown as { allNum: number;  projectAllList: any[] }
        this.total = allNum
        this.projectPricetableData = projectAllList
    }

    handleBtn(id: number) {
        return menuBtn(id)
    }


    // 生成 souCourseTypeName
    getMultipleSouCourseTypeName(souCourseTypeIdList: number[]): string {
        let souCourseTypeName = ''
        souCoueTypeList.forEach((item) => {
            if (souCourseTypeIdList.includes(item.value)) {
                const nameArr = souCourseTypeName.split('+')
                // 判断当前生成的名字中有几个 +
                if (nameArr.length === souCourseTypeIdList.length) {
                    souCourseTypeName += item.label
                } else {
                    souCourseTypeName += item.label + '+'
                }
            }
        })
        return souCourseTypeName
    }


    async getMarketCooperationPrevLevel() {
        const data: any = await getMarketCooperationPrevLevel(
            {
                page: this.marketLevelPage,
                limit: this.marketLevelSize,
                id: this.data.id,
                name: this.cooperativePartnerName
            }
        )
        this.marketCooperationPrevLevelList = [...this.marketCooperationPrevLevelList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.marketCooperationPrevLevelList.length; i++) {
            if (!obj[this.marketCooperationPrevLevelList[i].id]) {
                result.push(this.marketCooperationPrevLevelList[i]);
                obj[this.marketCooperationPrevLevelList[i].id] = true;
            }
        }
        this.marketCooperationPrevLevelList = result
    }



    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel(
                {
                    page: this.marketLevelPage,
                    name: query,
                    id: this.data.id
                }
            )
            this.marketCooperationPrevLevelList = result.marketCooperationList
        }
    }


    clearCooperativePartner() {
        this.marketCooperationPrevLevelList = []
        this.editFiles.marketCooperationId = null
        this.sourceName = ''
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketCooperationPrevLevel()
    }

    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketCooperationPrevLevel();
    }


    // 驳回审批
    clickRejectButton(status: number) {
        this.status = status
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.opinion = data.reviewIdea
        this.approvalVisible = false
        this.reviewDialogConfirm()
    }

    /*
 * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.opinion = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }
}
